<div class="row tradslag-search-row">
    <div class="col-6 mx-0 tradslag-search-label">
        <span>Tall</span>
    </div>
    <div class="col-6">
        <rask-input-number
            class="tradslag-input"
            label="MINSTA ANDEL"
            [(ngModel)]="searchFilter.skogligdata.tradslag.tall"
            placeholder="%"
            [append]="true"
            [required]="false"
            [max]="100"
            [min]="0"
            aid="inputTall">
        </rask-input-number>
    </div>
</div>
<div class="row tradslag-search-row">
    <div class="col-6 mx-0 tradslag-search-label">
        <span>Gran</span>
    </div>
    <div class="col-6">
        <rask-input-number
            class="tradslag-input hide-input-label"
            [(ngModel)]="searchFilter.skogligdata.tradslag.gran"
            placeholder="%"
            [append]="true"
            [required]="false"
            [max]="100"
            [min]="0"
            aid="inputGran">
        </rask-input-number>
    </div>
</div>

<div class="row tradslag-search-row">
    <div class="col-6 mx-0 tradslag-search-label">
        <span>Löv</span>
    </div>
    <div class="col-6">
        <rask-input-number
            class="tradslag-input hide-input-label"
            [(ngModel)]="searchFilter.skogligdata.tradslag.lov"
            placeholder="%"
            [append]="true"
            [required]="false"
            [max]="100"
            [min]="0"
            aid="inputLov">
        </rask-input-number>
    </div>
</div>
<div class="row tradslag-search-row">
    <div class="col-6 mx-0 tradslag-search-label">
        <span>Contorta</span>
    </div>
    <div class="col-6">
        <rask-input-number
            class="tradslag-input hide-input-label"
            [(ngModel)]="searchFilter.skogligdata.tradslag.contorta"
            placeholder="%"
            [append]="true"
            [required]="false"
            [max]="100"
            [min]="0"
            aid="inputContorta">
        </rask-input-number>
    </div>
</div>